// extracted by mini-css-extract-plugin
module.exports = {"cashierExpressButtonsContainer":"_1-lx6"};